export const en = {
  nav: { services: "Services", sectors: "Sectors", loans: "Loans", team: "Leadership", contact: "Contact", cta: "Request Funding" },
  hero: {
    eyebrow: "Canadian Institutional Capital",
    line1: "Capital that moves",
    line2: "industries forward",
    sub: "Pacific Investment Group deploys large-scale investment, loans and strategic partnerships across seven essential sectors — from agriculture and education to infrastructure and aviation.",
    cta1: "Request Funding",
    cta2: "Explore Our Services",
    scroll: "Scroll to explore",
    m1: "Capital deployed",
    m2: "Projects funded",
    m3: "Client satisfaction",
    m4: "Core sectors",
  },
  services: {
    eyebrow: "What we do",
    title: "Three ways we build",
    sub: "Institutional capital, structured for the businesses that keep the world running.",
    s1t: "Investment",
    s1d: "Institutional equity and joint ventures that scale promising enterprises into category leaders.",
    s1f1: "Equity & joint ventures",
    s1f2: "Project structuring",
    s1f3: "Long-horizon growth",
    s2t: "Loans",
    s2d: "Large-scale debt financing for small and big businesses — commercial loans structured for growth.",
    s2f1: "$500K to $100M+",
    s2f2: "Fast approval",
    s2f3: "Flexible repayment",
    s3t: "Partnership",
    s3d: "Strategic co-investments with hands-on operational guidance and global networks.",
    s3f1: "Co-investment models",
    s3f2: "Operational guidance",
    s3f3: "Global networks",
  },
  sectors: {
    eyebrow: "Where we invest",
    title: "Seven sectors. One standard.",
    sub: "We commit large-scale capital to the industries that shape the next century.",
    ag: "Agriculture", agd: "Modern AgTech and sustainable farming operations at scale.",
    edu: "Education", edud: "Campus development and next-generation learning infrastructure.",
    re: "Real Estate", red: "Commercial, residential and mixed-use development capital.",
    ind: "Industrial Development", indd: "Manufacturing plants, logistics parks and industrial zones.",
    inf: "Infrastructure", infd: "Transport corridors, energy assets and public utilities.",
    aut: "Automation", autd: "Robotics and AI-driven manufacturing systems.",
    avi: "Aviation", avid: "Aircraft leasing, fleet financing and airport development.",
  },
  loans: {
    eyebrow: "Debt financing",
    title: "Large-scale loans for serious businesses.",
    desc: "From $500K to $100M and beyond, we structure commercial debt for small and big businesses — fast approvals, flexible repayment and terms that protect your equity.",
    f1: "Flexible repayment terms",
    f2: "Fast approval process",
    f3: "Competitive rates",
    f4: "No equity dilution",
    slider: "Your financing need",
    cta: "Start a loan enquiry",
    steps: "Enquiry → Review → Approval → Funding",
  },
  stats: { l1: "Capital deployed", l2: "Projects funded", l3: "Client satisfaction", l4: "Core sectors" },
  marquee: ["Investment", "Agriculture", "Loans", "Education", "Partnership", "Real Estate", "Infrastructure", "Automation", "Aviation"],
  team: {
    eyebrow: "Leadership",
    title: "The people behind the capital.",
    sub: "A diverse executive team with decades of experience across global markets.",
    r1: "Chief Executive Officer",
    r2: "Senior VP, Global Investments",
    r3: "Head of Infrastructure & Debt Financing",
    r4: "Director, Real Estate & Sustainable Development",
    r5: "Chief Financial Officer",
    r6: "General Counsel & Compliance",
  },
  form: {
    eyebrow: "Get in touch",
    title: "Tell us about your project.",
    sub: "Share a few details and our team will respond within one business day.",
    name: "Full name",
    email: "Email address",
    phone: "Phone",
    company: "Company",
    service: "I'm interested in",
    sector: "Sector",
    amount: "Financing amount",
    amountPh: "e.g. $2.5M",
    message: "About your project",
    messagePh: "Tell us briefly about your business and funding needs…",
    pick: "Select a sector",
    submit: "Submit Enquiry",
    submitting: "Submitting…",
    success: "Enquiry received — our team will contact you within 24 hours.",
    error: "Something went wrong. Please try again or reach us on WhatsApp.",
    required: "Please fill in your name, email and message.",
    invalidEmail: "Please enter a valid email address.",
    safe: "Your information is always kept confidential and 100% safe.",
  },
  contact: {
    eyebrow: "Contact",
    title: "Talk to us directly.",
    whatsapp: "WhatsApp",
    waCta: "Chat on WhatsApp",
    email: "Email",
    emCta: "Send an email",
    address: "Office",
    dir: "Get directions",
    hours: "Mon–Fri, 9:00–18:00 EST",
  },
  footer: {
    tagline: "Institutional capital for the sectors that shape tomorrow.",
    rights: "© 2026 Pacific Investment Group. All rights reserved.",
    privacy: "Privacy",
    disclaimer: "Pacific Investment Group provides commercial financing and investment services. All enquiries are subject to review and approval.",
  },
};

export const fr = {
  nav: { services: "Services", sectors: "Secteurs", loans: "Prêts", team: "Direction", contact: "Contact", cta: "Demander un financement" },
  hero: {
    eyebrow: "Capital institutionnel canadien",
    line1: "Le capital qui fait",
    line2: "avancer les industries",
    sub: "Pacific Investment Group déploie des investissements à grande échelle, des prêts et des partenariats stratégiques dans sept secteurs essentiels — de l'agriculture et l'éducation aux infrastructures et l'aviation.",
    cta1: "Demander un financement",
    cta2: "Découvrir nos services",
    scroll: "Faites défiler",
    m1: "Capital déployé",
    m2: "Projets financés",
    m3: "Satisfaction client",
    m4: "Secteurs clés",
  },
  services: {
    eyebrow: "Ce que nous faisons",
    title: "Trois façons de bâtir",
    sub: "Un capital institutionnel, structuré pour les entreprises qui font tourner le monde.",
    s1t: "Investissement",
    s1d: "Des prises de participation et coentreprises institutionnelles qui transforment des entreprises prometteuses en leaders.",
    s1f1: "Participation & coentreprises",
    s1f2: "Structuration de projets",
    s1f3: "Croissance à long terme",
    s2t: "Prêts",
    s2d: "Un financement par la dette à grande échelle pour les petites et grandes entreprises — des prêts commerciaux structurés pour la croissance.",
    s2f1: "500 K$ à 100 M$+",
    s2f2: "Approbation rapide",
    s2f3: "Remboursement flexible",
    s3t: "Partenariat",
    s3d: "Des co-investissements stratégiques avec un accompagnement opérationnel et des réseaux mondiaux.",
    s3f1: "Modèles de co-investissement",
    s3f2: "Accompagnement opérationnel",
    s3f3: "Réseaux mondiaux",
  },
  sectors: {
    eyebrow: "Où nous investissons",
    title: "Sept secteurs. Une exigence.",
    sub: "Nous engageons des capitaux importants dans les industries qui façonnent le prochain siècle.",
    ag: "Agriculture", agd: "AgTech moderne et exploitation agricole durable à grande échelle.",
    edu: "Éducation", edud: "Développement de campus et infrastructures d'apprentissage nouvelle génération.",
    re: "Immobilier", red: "Capital de développement commercial, résidentiel et mixte.",
    ind: "Développement industriel", indd: "Usines de fabrication, parcs logistiques et zones industrielles.",
    inf: "Infrastructures", infd: "Corridors de transport, actifs énergétiques et services publics.",
    aut: "Automatisation", autd: "Robotique et systèmes de fabrication pilotés par l'IA.",
    avi: "Aviation", avid: "Location d'avions, financement de flottes et développement d'aéroports.",
  },
  loans: {
    eyebrow: "Financement par la dette",
    title: "Des prêts à grande échelle pour des entreprises ambitieuses.",
    desc: "De 500 K$ à 100 M$ et plus, nous structurons de la dette commerciale pour les petites et grandes entreprises — approbation rapide, remboursement flexible et des conditions qui protègent votre capital.",
    f1: "Conditions de remboursement flexibles",
    f2: "Processus d'approbation rapide",
    f3: "Taux compétitifs",
    f4: "Aucune dilution du capital",
    slider: "Votre besoin de financement",
    cta: "Commencer une demande de prêt",
    steps: "Demande → Examen → Approbation → Financement",
  },
  stats: { l1: "Capital déployé", l2: "Projets financés", l3: "Satisfaction client", l4: "Secteurs clés" },
  marquee: ["Investissement", "Agriculture", "Prêts", "Éducation", "Partenariat", "Immobilier", "Infrastructures", "Automatisation", "Aviation"],
  team: {
    eyebrow: "Direction",
    title: "Les visages derrière le capital.",
    sub: "Une équipe dirigeante diversifiée forte de décennies d'expérience sur les marchés mondiaux.",
    r1: "Directeur général (CEO)",
    r2: "VP principale, Investissements mondiaux",
    r3: "Responsable des infrastructures & financement par la dette",
    r4: "Directrice, Immobilier & développement durable",
    r5: "Directeur financier (CFO)",
    r6: "Directrice juridique & conformité",
  },
  form: {
    eyebrow: "Contactez-nous",
    title: "Parlez-nous de votre projet.",
    sub: "Partagez quelques détails et notre équipe vous répondra sous un jour ouvré.",
    name: "Nom complet",
    email: "Adresse e-mail",
    phone: "Téléphone",
    company: "Entreprise",
    service: "Je suis intéressé par",
    sector: "Secteur",
    amount: "Montant du financement",
    amountPh: "ex. 2,5 M$",
    message: "À propos de votre projet",
    messagePh: "Décrivez brièvement votre entreprise et vos besoins de financement…",
    pick: "Choisissez un secteur",
    submit: "Envoyer la demande",
    submitting: "Envoi en cours…",
    success: "Demande reçue — notre équipe vous contactera sous 24 heures.",
    error: "Une erreur est survenue. Réessayez ou contactez-nous sur WhatsApp.",
    required: "Veuillez renseigner votre nom, votre e-mail et votre message.",
    invalidEmail: "Veuillez saisir une adresse e-mail valide.",
    safe: "Vos informations restent toujours confidentielles et 100 % sûres.",
  },
  contact: {
    eyebrow: "Contact",
    title: "Parlons-en directement.",
    whatsapp: "WhatsApp",
    waCta: "Discuter sur WhatsApp",
    email: "E-mail",
    emCta: "Envoyer un e-mail",
    address: "Bureau",
    dir: "Itinéraire",
    hours: "Lun–Ven, 9h–18h (EST)",
  },
  footer: {
    tagline: "Un capital institutionnel pour les secteurs qui façonnent demain.",
    rights: "© 2026 Pacific Investment Group. Tous droits réservés.",
    privacy: "Confidentialité",
    disclaimer: "Pacific Investment Group fournit des services de financement commercial et d'investissement. Toute demande est soumise à examen et approbation.",
  },
};

export const es = {
  nav: { services: "Servicios", sectors: "Sectores", loans: "Préstamos", team: "Liderazgo", contact: "Contacto", cta: "Solicitar financiamiento" },
  hero: {
    eyebrow: "Capital institucional canadiense",
    line1: "Capital que impulsa",
    line2: "las industrias hacia adelante",
    sub: "Pacific Investment Group despliega inversión a gran escala, préstamos y alianzas estratégicas en siete sectores esenciales — desde la agricultura y la educación hasta la infraestructura y la aviación.",
    cta1: "Solicitar financiamiento",
    cta2: "Explorar nuestros servicios",
    scroll: "Desplázate para explorar",
    m1: "Capital invertido",
    m2: "Proyectos financiados",
    m3: "Satisfacción del cliente",
    m4: "Sectores clave",
  },
  services: {
    eyebrow: "Lo que hacemos",
    title: "Tres formas de construir",
    sub: "Capital institucional, estructurado para las empresas que mantienen el mundo en marcha.",
    s1t: "Inversión",
    s1d: "Capital institucional y empresas conjuntas que convierten empresas prometedoras en líderes del sector.",
    s1f1: "Capital y empresas conjuntas",
    s1f2: "Estructuración de proyectos",
    s1f3: "Crecimiento a largo plazo",
    s2t: "Préstamos",
    s2d: "Financiamiento de deuda a gran escala para pequeñas y grandes empresas — préstamos comerciales estructurados para crecer.",
    s2f1: "$500K a $100M+",
    s2f2: "Aprobación rápida",
    s2f3: "Pago flexible",
    s3t: "Alianzas",
    s3d: "Coinversiones estratégicas con guía operativa práctica y redes globales.",
    s3f1: "Modelos de coinversión",
    s3f2: "Guía operativa",
    s3f3: "Redes globales",
  },
  sectors: {
    eyebrow: "Dónde invertimos",
    title: "Siete sectores. Un estándar.",
    sub: "Comprometemos capital a gran escala con las industrias que moldean el próximo siglo.",
    ag: "Agricultura", agd: "AgTech moderno y operaciones agrícolas sostenibles a gran escala.",
    edu: "Educación", edud: "Desarrollo de campus e infraestructura educativa de nueva generación.",
    re: "Bienes Raíces", red: "Capital de desarrollo comercial, residencial y de uso mixto.",
    ind: "Desarrollo Industrial", indd: "Plantas manufactureras, parques logísticos y zonas industriales.",
    inf: "Infraestructura", infd: "Corredores de transporte, activos energéticos y servicios públicos.",
    aut: "Automatización", autd: "Robótica y sistemas de fabricación impulsados por IA.",
    avi: "Aviación", avid: "Arrendamiento de aeronaves, financiamiento de flotas y desarrollo de aeropuertos.",
  },
  loans: {
    eyebrow: "Financiamiento de deuda",
    title: "Préstamos a gran escala para negocios serios.",
    desc: "Desde $500K hasta más de $100M, estructuramos deuda comercial para pequeñas y grandes empresas — aprobaciones rápidas, pago flexible y condiciones que protegen tu capital.",
    f1: "Condiciones de pago flexibles",
    f2: "Proceso de aprobación rápido",
    f3: "Tasas competitivas",
    f4: "Sin dilución de capital",
    slider: "Tu necesidad de financiamiento",
    cta: "Iniciar una solicitud de préstamo",
    steps: "Solicitud → Revisión → Aprobación → Financiamiento",
  },
  stats: { l1: "Capital invertido", l2: "Proyectos financiados", l3: "Satisfacción del cliente", l4: "Sectores clave" },
  marquee: ["Inversión", "Agricultura", "Préstamos", "Educación", "Alianzas", "Bienes Raíces", "Infraestructura", "Automatización", "Aviación"],
  team: {
    eyebrow: "Liderazgo",
    title: "Las personas detrás del capital.",
    sub: "Un equipo ejecutivo diverso con décadas de experiencia en mercados globales.",
    r1: "Director Ejecutivo (CEO)",
    r2: "VP Sénior, Inversiones Globales",
    r3: "Director de Infraestructura y Financiamiento de Deuda",
    r4: "Directora, Bienes Raíces y Desarrollo Sostenible",
    r5: "Director Financiero (CFO)",
    r6: "Directora Legal y Cumplimiento",
  },
  form: {
    eyebrow: "Contáctanos",
    title: "Cuéntanos sobre tu proyecto.",
    sub: "Comparte algunos detalles y nuestro equipo responderá en un día hábil.",
    name: "Nombre completo",
    email: "Correo electrónico",
    phone: "Teléfono",
    company: "Empresa",
    service: "Me interesa",
    sector: "Sector",
    amount: "Monto del financiamiento",
    amountPh: "p. ej. $2.5M",
    message: "Sobre tu proyecto",
    messagePh: "Cuéntanos brevemente sobre tu negocio y tus necesidades de financiamiento…",
    pick: "Selecciona un sector",
    submit: "Enviar solicitud",
    submitting: "Enviando…",
    success: "Solicitud recibida — nuestro equipo te contactará en 24 horas.",
    error: "Algo salió mal. Inténtalo de nuevo o escríbenos por WhatsApp.",
    required: "Por favor completa tu nombre, correo y mensaje.",
    invalidEmail: "Por favor ingresa un correo electrónico válido.",
    safe: "Su información siempre se mantiene confidencial y 100% segura.",
  },
  contact: {
    eyebrow: "Contacto",
    title: "Habla directamente con nosotros.",
    whatsapp: "WhatsApp",
    waCta: "Chatear por WhatsApp",
    email: "Correo",
    emCta: "Enviar un correo",
    address: "Oficina",
    dir: "Cómo llegar",
    hours: "Lun–Vie, 9:00–18:00 EST",
  },
  footer: {
    tagline: "Capital institucional para los sectores que moldean el mañana.",
    rights: "© 2026 Pacific Investment Group. Todos los derechos reservados.",
    privacy: "Privacidad",
    disclaimer: "Pacific Investment Group brinda servicios de financiamiento comercial e inversión. Todas las solicitudes están sujetas a revisión y aprobación.",
  },
};

export const pt = {
  nav: { services: "Serviços", sectors: "Setores", loans: "Empréstimos", team: "Liderança", contact: "Contato", cta: "Solicitar financiamento" },
  hero: {
    eyebrow: "Capital institucional canadense",
    line1: "Capital que move",
    line2: "indústrias para frente",
    sub: "A Pacific Investment Group realiza investimentos em larga escala, empréstimos e parcerias estratégicas em sete setores essenciais — da agricultura e educação à infraestrutura e aviação.",
    cta1: "Solicitar financiamento",
    cta2: "Explorar nossos serviços",
    scroll: "Role para explorar",
    m1: "Capital investido",
    m2: "Projetos financiados",
    m3: "Satisfação do cliente",
    m4: "Setores principais",
  },
  services: {
    eyebrow: "O que fazemos",
    title: "Três formas de construir",
    sub: "Capital institucional, estruturado para as empresas que mantêm o mundo em funcionamento.",
    s1t: "Investimento",
    s1d: "Participação acionária institucional e joint ventures que transformam empresas promissoras em líderes de mercado.",
    s1f1: "Participação & joint ventures",
    s1f2: "Estruturação de projetos",
    s1f3: "Crescimento de longo prazo",
    s2t: "Empréstimos",
    s2d: "Financiamento de dívida em larga escala para pequenas e grandes empresas — empréstimos comerciais estruturados para o crescimento.",
    s2f1: "US$500 mil a US$100 mi+",
    s2f2: "Aprovação rápida",
    s2f3: "Pagamento flexível",
    s3t: "Parceria",
    s3d: "Coinvestimentos estratégicos com orientação operacional prática e redes globais.",
    s3f1: "Modelos de coinvestimento",
    s3f2: "Orientação operacional",
    s3f3: "Redes globais",
  },
  sectors: {
    eyebrow: "Onde investimos",
    title: "Sete setores. Um padrão.",
    sub: "Comprometemos capital em larga escala com as indústrias que moldarão o próximo século.",
    ag: "Agricultura", agd: "AgTech moderna e operações agrícolas sustentáveis em escala.",
    edu: "Educação", edud: "Desenvolvimento de campi e infraestrutura de aprendizado de nova geração.",
    re: "Imóveis", red: "Capital de desenvolvimento comercial, residencial e de uso misto.",
    ind: "Desenvolvimento Industrial", indd: "Fábricas, parques logísticos e zonas industriais.",
    inf: "Infraestrutura", infd: "Corredores de transporte, ativos de energia e utilidades públicas.",
    aut: "Automação", autd: "Robótica e sistemas de manufatura orientados por IA.",
    avi: "Aviação", avid: "Locação de aeronaves, financiamento de frotas e desenvolvimento de aeroportos.",
  },
  loans: {
    eyebrow: "Financiamento de dívida",
    title: "Empréstimos em larga escala para negócios sérios.",
    desc: "De US$500 mil a mais de US$100 milhões, estruturamos dívida comercial para pequenas e grandes empresas — aprovações rápidas, pagamento flexível e condições que protegem seu capital.",
    f1: "Condições de pagamento flexíveis",
    f2: "Processo de aprovação rápido",
    f3: "Taxas competitivas",
    f4: "Sem diluição de capital",
    slider: "Sua necessidade de financiamento",
    cta: "Iniciar uma solicitação de empréstimo",
    steps: "Solicitação → Análise → Aprovação → Financiamento",
  },
  stats: { l1: "Capital investido", l2: "Projetos financiados", l3: "Satisfação do cliente", l4: "Setores principais" },
  marquee: ["Investimento", "Agricultura", "Empréstimos", "Educação", "Parceria", "Imóveis", "Infraestrutura", "Automação", "Aviação"],
  team: {
    eyebrow: "Liderança",
    title: "As pessoas por trás do capital.",
    sub: "Uma equipe executiva diversa com décadas de experiência em mercados globais.",
    r1: "Diretor Executivo (CEO)",
    r2: "VP Sênior, Investimentos Globais",
    r3: "Diretor de Infraestrutura e Financiamento de Dívida",
    r4: "Diretora, Imóveis e Desenvolvimento Sustentável",
    r5: "Diretor Financeiro (CFO)",
    r6: "Diretora Jurídica e Compliance",
  },
  form: {
    eyebrow: "Fale conosco",
    title: "Conte-nos sobre seu projeto.",
    sub: "Compartilhe alguns detalhes e nossa equipe responderá em um dia útil.",
    name: "Nome completo",
    email: "Endereço de e-mail",
    phone: "Telefone",
    company: "Empresa",
    service: "Tenho interesse em",
    sector: "Setor",
    amount: "Valor do financiamento",
    amountPh: "ex.: US$2,5 mi",
    message: "Sobre seu projeto",
    messagePh: "Conte brevemente sobre sua empresa e suas necessidades de financiamento…",
    pick: "Selecione um setor",
    submit: "Enviar solicitação",
    submitting: "Enviando…",
    success: "Solicitação recebida — nossa equipe entrará em contato em 24 horas.",
    error: "Algo deu errado. Tente novamente ou fale conosco pelo WhatsApp.",
    required: "Preencha seu nome, e-mail e mensagem.",
    invalidEmail: "Insira um endereço de e-mail válido.",
    safe: "Suas informações são sempre mantidas confidenciais e 100% seguras.",
  },
  contact: {
    eyebrow: "Contato",
    title: "Fale diretamente conosco.",
    whatsapp: "WhatsApp",
    waCta: "Conversar no WhatsApp",
    email: "E-mail",
    emCta: "Enviar um e-mail",
    address: "Escritório",
    dir: "Como chegar",
    hours: "Seg–Sex, 9h–18h (EST)",
  },
  footer: {
    tagline: "Capital institucional para os setores que moldam o amanhã.",
    rights: "© 2026 Pacific Investment Group. Todos os direitos reservados.",
    privacy: "Privacidade",
    disclaimer: "A Pacific Investment Group oferece serviços de financiamento comercial e investimento. Todas as solicitações estão sujeitas a análise e aprovação.",
  },
};
